<template>
  <div id="footer">
    <b-container class="footmenu">
      <b-link to="/" class="float-left">
        <img src="/static/images/logo.png" alt="Lifestyle.zindaa.mn" />
      </b-link>
      <b-nav>
        <b-nav-item
          v-for="item in footerMenu"
          :key="item.id"
          :to="'/s/' + item.slug"
          >{{ item.name }}</b-nav-item
        >
      </b-nav>
    </b-container>
    <b-container class="copycc">
      2019 &copy; LIFESTYLE All Rights Reserved.
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      footerMenu: {}
    };
  },
  mounted() {
    this.footerMenu = window.init.static;
  }
};
</script>
